"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("elevate-ui/Typography"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var _Cancel = _interopRequireDefault(require("../Components/Common/Cancel"));

var _Submit = _interopRequireDefault(require("../Components/Common/Submit"));

var SidebarForm = function SidebarForm(_ref) {
  var onSave = _ref.onSave,
      type = _ref.type,
      children = _ref.children,
      cancelEdit = _ref.cancelEdit,
      breadcrumbs = _ref.breadcrumbs,
      classes = _ref.classes,
      internals = _ref.internals;
  var crumbs = (breadcrumbs || []).slice(0, -1);
  var last = (breadcrumbs || []).slice(-1)[0];
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    type: "heading3",
    gutterBottom: true
  }, "Editing ", type), /*#__PURE__*/_react["default"].createElement("ul", {
    className: classes.breadcrumbs
  }, crumbs.map(function (crumb, idx) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: "crumb-".concat(crumb.id)
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#",
      onClick: function onClick(e) {
        return internals.showSidebar(e, crumb.id);
      }
    }, crumb.label), /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.breadCrumbSeparator
    }, " / "));
  }), crumbs && !!crumbs.length && last && /*#__PURE__*/_react["default"].createElement("li", {
    key: "crumb-".concat(last.id)
  }, last.label)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.grid
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.buttonGroup
  }, /*#__PURE__*/_react["default"].createElement(_Cancel["default"], {
    className: classes.halfButton,
    cancelEdit: cancelEdit
  }), /*#__PURE__*/_react["default"].createElement(_Submit["default"], {
    className: classes.halfButton
  })));
};

var styles = function styles(theme) {
  return {
    buttonGroup: {
      display: "flex",
      flexFlow: "row wrap",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "16px"
    },
    halfButton: {
      flex: "0 1 45%"
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "1fr",
      gridGap: "24px"
    },
    breadcrumbs: {
      marginBottom: "10px",
      marginTop: "-10px",
      "& > li": {
        display: "inline"
      }
    },
    breadCrumbSeparator: {
      fontSize: "0.8rem",
      color: "#111"
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "SidebarForm"
})(SidebarForm);

exports["default"] = _default;